import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { cloneDeep } from 'lodash-es';
import { Subscription } from 'rxjs';
import { EmailData } from '../../../../../domain/document.model';
import { ValidationError } from '../../../../../domain/error.model';
import { LsnErrorStateMatcher } from '../../../../shared/middleware/error-state-matcher';
import { DialogAction } from '../../../store/dialog.action';
import { ErrorsState } from '../../../store/errors.state';
import { OfferAction } from '../../../store/offer.action';
import { OfferState } from '../../../store/offer.state';

@Component({
    selector: 'app-email-data-dialog',
    templateUrl: './email-data-dialog.component.html'
})
export class EmailDataDialogComponent implements OnInit {

    subscriptions: Subscription[] = [];
    errors: ValidationError[] = [];
    emailData: EmailData;

    matchers = {
        clause: new LsnErrorStateMatcher(this, 'emailData.clause'),
        email: new LsnErrorStateMatcher(this, 'emailData.email'),
    };
    extended = false;

    constructor(private store: Store,
                @Inject(MAT_DIALOG_DATA) data) {
        this.emailData = cloneDeep(data.emailData);
    }


    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(ErrorsState.getAsideErrors).subscribe(errors => this.errors = errors),
        )
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    cancel() {
        this.store.dispatch(new DialogAction.CloseAll());
    }

    save() {
        const offer = this.store.selectSnapshot(OfferState.getOffer);
        this.store.dispatch(new OfferAction.SaveEmailDataForIOffer(offer.id, this.emailData));
    }
}
